import type { GetServerSideProps } from 'next';

import { getLocaleFromParams } from '@/utils/locale';

import {
  getBoutiqueDataWithTrackingKey,
  navToAppointmentPath,
} from '@/lib/boutique/helpers';
import { commonServerSideProps } from '@/lib/commonPageStaticProps';
import { resolveContentDraftMode } from '@/lib/draftMode';
import { CacheHeaderType } from '@/lib/revalidate';
import { AppointmentView } from '@/views/AppointmentView';
export const getServerSideProps: GetServerSideProps = commonServerSideProps(
  async (context) => {
    const draftMode = resolveContentDraftMode(context);
    const locale = getLocaleFromParams(context?.params);
    const countryCodeOrTrackingKey = context?.params?.country;
    if (countryCodeOrTrackingKey && countryCodeOrTrackingKey.length <= 3) {
      return {
        props: {},
      };
    }
    try {
      const boutiqueResult = await getBoutiqueDataWithTrackingKey(
        false,
        countryCodeOrTrackingKey as string,
        locale,
        !!draftMode,
      );

      if (boutiqueResult === 'no hit') {
        return {
          notFound: true,
        };
      } else {
        const slug = boutiqueResult?.slug;
        const countryCode = boutiqueResult?.countryCode?.toLowerCase();
        return {
          redirect: {
            destination: navToAppointmentPath(
              countryCode as string,
              slug as string,
              locale,
            ),
          },
        };
      }
    } catch (error) {
      return {
        notFound: true,
      };
    }
  },
  CacheHeaderType.NO_CACHE,
);

export default AppointmentView;
